import { Badge } from '@/components/ui/badge';
import { ArrowRight, Calendar } from 'lucide-react';

const CommitmentTimeline = ({ commitment }) => {
  const movements = commitment.movements || [];
  const original_date = commitment.original_date || commitment.entry_date;
  const current_date = commitment.current_date || commitment.entry_date;

  // Build timeline events: creation + movements
  const events = [
    {
      date: original_date,
      type: 'created',
      label: 'Created',
      user: commitment.filled_by_name || 'System',
      timestamp: commitment.created_at,
    },
    ...movements.map((m) => ({
      date: m.to_date,
      type: 'moved',
      label: 'Moved',
      user: m.moved_by_name,
      timestamp: m.moved_at,
      note: m.note,
      from_date: m.from_date,
    })),
  ];

  const formatDateTime = (isoString) => {
    if (!isoString) return 'Unknown';
    return new Date(isoString).toLocaleString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className="p-4">
      <div className="flex items-start space-x-3 overflow-x-auto pb-4">
        {events.map((event, idx) => (
          <div key={idx} className="flex items-center">
            <div className="flex flex-col items-center min-w-[140px]">
              <Badge variant={event.type === 'created' ? 'default' : 'secondary'} className="mb-2">
                <Calendar className="w-3 h-3 mr-1" />
                {event.date}
              </Badge>
              <div className="text-sm font-medium text-center">{event.label}</div>
              <div className="text-xs text-gray-600 text-center mt-1">{event.user}</div>
              {event.note && (
                <div className="text-xs text-gray-500 italic mt-1 text-center max-w-[130px]">
                  "{event.note}"
                </div>
              )}
              <div className="text-xs text-gray-400 mt-1 text-center">
                {formatDateTime(event.timestamp)}
              </div>
            </div>
            {idx < events.length - 1 && (
              <ArrowRight className="w-5 h-5 text-gray-300 flex-shrink-0 mx-2" />
            )}
          </div>
        ))}
      </div>
      {movements.length === 0 && (
        <div className="text-center text-gray-500 py-4">
          No movement history - commitment has not been moved yet
        </div>
      )}
    </div>
  );
};

export default CommitmentTimeline;
